



import { defineComponent, computed } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import getComponent from "./views";

export default defineComponent({
  name: "StreamMessage",
  props: {
    message: { type: Object as () => Message, required: true },
  },
  setup(props) {
    const messageView = computed(() => getComponent(props.message));

    return { messageView, getComponent };
  },
});
